export enum RejectionTreatmentType {
    AntiLymphocyteAntibodyTherapy = 0,
    Steroids = 1,
    IVIg = 2,
    Plasmapheresis = 3,
    NotTreated = 4,
    Other = 5
}